<script setup lang="ts">
import { ref } from 'vue'

import type { useKeywordArea } from '../../composables/useKeywordArea'

import { useI18n } from '@/shared/i18n'
import { Alert, Button, Modal, TagInput, useToast } from '@/shared/ui'

const props = defineProps<{
  titleKey: string
  area: ReturnType<typeof useKeywordArea>
}>()
const emit = defineEmits<{ close: [] }>()
const { t } = useI18n()
const toast = useToast()
const open = ref(true)
const keywords = ref([...props.area.keywords.value])

async function save(): Promise<void> {
  const result = await props.area.save(keywords.value)
  if (!result) return
  toast.success(t('workspaceDefinitions.common.saved'))
  emit('close')
}
</script>

<template>
  <Modal v-model="open" :title="t(titleKey)" size="md" @close="emit('close')">
    <template #body>
      <div class="keyword-edit-modal__body grid gap-sm">
        <TagInput
          v-model="keywords"
          :label="t(titleKey)"
          :placeholder="t('workspaceDefinitions.keywords.placeholder', { max: area.max })"
          :add-label="t('workspaceDefinitions.common.add')"
          :max="area.max"
          add-on-blur
        />
        <p class="keyword-edit-modal__count m-0 text-muted text-[0.75rem] text-end">
          {{ t('workspaceDefinitions.keywords.count', { count: keywords.length, max: area.max }) }}
        </p>
        <Alert v-if="area.error.value" tone="danger">
          {{ t('workspaceDefinitions.common.saveError') }}
        </Alert>
      </div>
    </template>
    <template #buttons>
      <div class="keyword-edit-modal__actions flex justify-end gap-sm">
        <Button variant="outline" size="sm" :disabled="area.pending.value" @click="emit('close')">
          {{ t('workspaceDefinitions.common.cancel') }}
        </Button>
        <Button size="sm" :loading="area.pending.value" @click="save">
          {{ t('workspaceDefinitions.common.save') }}
        </Button>
      </div>
    </template>
  </Modal>
</template>
